import React from 'react'
import BaseIcon from 'react-icon-base'

const UA = props => (
  <BaseIcon width="21" height="15" viewBox="0 0 21 15" {...props}>
    <title>UA</title>
    <defs>
      <rect id="path-1" x="0" y="0" width="21" height="15" rx="2" />
      <rect id="path-3" x="0.5" y="0.5" width="20" height="14" rx="1" />
    </defs>
    <g id=":)" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Flags-by-@lucchaissac" transform="translate(-205.000000, -255.000000)">
        <g id="UA" transform="translate(205.000000, 255.000000)">
          <mask id="mask-2" fill="white">
            <use xlinkHref="#path-1" />
          </mask>
          <use id="background" fill="#126CCF" xlinkHref="#path-1" />
          <rect id="bottom" fill="#FED949" mask="url(#mask-2)" x="0" y="8" width="21" height="7" />
          <mask id="mask-4" fill="white">
            <use xlinkHref="#path-3" />
          </mask>
          <use id="overlay" strokeOpacity="0.156646286" stroke="#2F343A" xlinkHref="#path-3" />
        </g>
      </g>
    </g>
  </BaseIcon>
)

export default UA
